import store from "@/store/index";
import {
  pularPagamentoParaImpressao,
  updateCompraInterface,
} from "@/service/firebase";
import posthog from "@/posthog";
import {
  contabilizaVendaSemCobranca,
  ORIGEM_PAGAMENTO_EVENTO,
} from "@/utils/cobrancaTotem";

// Totem de evento com a cobrança desligada não passa pelo pinpad, mas a venda
// tem de entrar no relatório assim mesmo: o parceiro contratou um pacote de
// fotos e o excedente é cobrado no fim do dia. O gestão considera concluída só
// a compra com `pago === true` — sem esta marcação a impressão cairia no balde
// das canceladas e sumiria da apuração.
//
// Retorna true só quando marcou a compra agora. O listener do Firestore chama
// esta função mais de uma vez para a mesma compra, e quem emite analytics
// precisa saber diferenciar a primeira vez das repetições.
export async function registrarVendaSemCobranca() {
  const totem = store.getters["totem/getTotem"];
  const compra = store.getters["compra/getCompra"];

  if (!contabilizaVendaSemCobranca(totem)) return false;
  if (!compra || !compra.id || compra.pago === true) return false;

  compra.pago = true;
  compra.origem_pagamento = ORIGEM_PAGAMENTO_EVENTO;
  // `tipoCartao` fica intocado de propósito: a quebra por forma de pagamento do
  // gestão soma só Crédito/Débito/Pix, e esta venda não entrou por nenhum
  // deles. O valor de tabela já está em `compra.valor` desde a escolha da
  // quantidade, então o total do dia soma sozinho.
  await updateCompraInterface(compra);
  return true;
}

// Cobrança desligada: a compra vai direto para a impressão. Em totem de EVENTO
// ela é contabilizada como venda antes de avançar — nos demais (desligamento
// temporário da cobrança) nada é marcado e o comportamento é o de sempre.
//
// A ordem importa: a etapa só muda depois da gravação, senão a tela de
// impressão já teria avançado a compra e a marcação escreveria por cima de uma
// etapa mais nova.
export async function finalizarCompraSemCobranca() {
  try {
    const registrou = await registrarVendaSemCobranca();
    if (registrou) {
      const compra = store.getters["compra/getCompra"];
      posthog.capture("payment_completed", {
        payment_method: "evento",
        purchase_value: compra.valor,
      });
    }
  } catch (erro) {
    // A impressão não pode ficar refém do relatório: se a marcação falhar, o
    // cliente ainda recebe a foto e o erro fica registrado.
    console.error("Falha ao contabilizar a venda do evento:", erro);
  }

  // Preserva a marca de pagamento desativado dos totens comuns para a
  // telemetria operacional; Evento continua contabilizado pelo fluxo acima.
  await pularPagamentoParaImpressao();
}
